// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".router-link-active[data-v-3cc1a619] {\n  font-weight: 500;\n}\n.dropdown-item .badge[data-v-3cc1a619] {\n  right: 0;\n  margin-top: 7px;\n}", ""]);
// Exports
module.exports = exports;
